var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99327 10.9726L0.210924 13.7324C-0.0700512 14.0231 -0.0700512 14.4842 0.210924 14.7749C0.351742 14.9169 0.543428 14.9967 0.743396 14.9967C0.943363 14.9967 1.13505 14.9169 1.27587 14.7749L4.03572 12.015C6.83183 14.2576 10.8931 13.9235 13.2852 11.2542C15.6773 8.58492 15.5659 4.51142 13.0314 1.97693C10.4969 -0.55755 6.42338 -0.669016 3.75409 1.72308C1.0848 4.11517 0.750734 8.17647 2.99327 10.9726ZM13.4927 6.76532C13.4927 9.66465 11.1423 12.015 8.24298 12.015C6.85067 12.015 5.51539 11.4619 4.53088 10.4774C3.54637 9.49291 2.99327 8.15763 2.99327 6.76532C2.99327 3.86598 5.34365 1.5156 8.24298 1.5156C11.1423 1.5156 13.4927 3.86598 13.4927 6.76532Z",
    fill: "#0A0A0A"
  })));
};
export default SvgSearchIcon;